export default __webpack_public_path__ + "static/media/rope.d353bf93.png";